import { useTranslation } from 'react-i18next';
import ContactCard from "../../../Component/sections/ContactCard/ContactCard";
import ContactForm from "../../../Component/sections/ContactForm/ContactForm";
import LandPage from "../../../Component/common/LandPage/LandPage"
import Navbar from "../../../Component/common/Navbar/Navbar";
import Topbar from "../../../Component/common/Topbar/Topbar";
import Footer from '../../../Component/common/Footer/Footer';

function ContactUS(){
  const { t } = useTranslation();
  return (
    <>
      <div className='contact-container'>
        <Topbar/>
        <Navbar/>
        <LandPage header={t('contactUs')} link={t('contactUs')} href='/contact-us' />
        <ContactForm/>
        <ContactCard/>
        <Footer/>
      </div>
    </>
  );
}
export default ContactUS